const isEntitlementTECloud = (entitlement) =>
  entitlement && entitlement.application === 'TECloud'

export default isEntitlementTECloud
